"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    globPaths: function() {
        return globPaths;
    },
    globValues: function() {
        return globValues;
    },
    glob: function() {
        return glob;
    }
});
var _globToRegexp = /*#__PURE__*/ _interopRequireDefault(require("glob-to-regexp"));
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function globPaths(globPattern, obj) {
    return glob(globPattern, obj, "path");
}
function globValues(globPattern, obj) {
    return glob(globPattern, obj, "value");
}
function glob(globPattern, obj, mode) {
    var objectPatchMatcher = toPathRegex(globPattern);
    var globByDepth = new Map();
    var result = [];
    function traverse(obj, path) {
        if (!obj) return result;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.keys(obj)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var currentPath = _toConsumableArray(path).concat([
                    key
                ]);
                var value = obj[key];
                if (objectPathMatches(objectPatchMatcher, currentPath)) {
                    result.push(mode === "path" ? currentPath.join(".") : value);
                } else if (typeof value === "object" && value !== null) {
                    if (globPattern.includes("**")) {
                        // if the glob pattern contains the globstar **, we need to traverse all the way down
                        traverse(value, currentPath);
                        continue;
                    }
                    // don't traverse if the path doesn't match partially
                    var partialMatcher = globByDepth.get(path.length);
                    if (!partialMatcher) {
                        partialMatcher = toPathRegex(globPattern.split(".").slice(0, path.length + 1).join("."));
                        globByDepth.set(path.length, partialMatcher);
                    }
                    var isPartialMatch = partialMatcher.test(currentPath.join("/"));
                    if (isPartialMatch) {
                        traverse(value, currentPath);
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    traverse(obj, []);
    return result;
}
var objectPathMatches = function(pathGlob, paths) {
    var path = paths.join("/");
    return pathGlob.test(path);
};
var toPathRegex = function(glob) {
    var pathGlob = glob.split(".").join("/"); // replace all dots with slashes
    return (0, _globToRegexp.default)(pathGlob, {
        extended: true,
        globstar: true
    });
};
